import * as Sentry from "@sentry/browser";

Sentry.init({
  dsn: "https://895dcb6632f4443585e03df602166d45@glitch.comitas.es/5",
  environment: process.env.REACT_APP_ENV || "development",
  // We recommend adjusting this value in production, or using tracesSampler for finer control
  tracesSampleRate: 1.0,
});
